import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=b31bdb9a&"
import script from "./alipay.vue?vue&type=script&lang=js&"
export * from "./alipay.vue?vue&type=script&lang=js&"
import style0 from "./alipay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports